module.exports = __webpack_public_path__ + "static/media/functionnality-rectangle-item.13683bef.svg";